import { request } from "../utils/request.js"

export const customerGroup_addNew = (pojo, args) => request({
    url: 'customerGroup/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerGroup_update = (pojo, args) => request({
    url: 'customerGroup/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerGroup_findPageForManage = (pojo, args) => request({
    url: 'customerGroup/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customerGroup_findPageForSelect = (pojo, args) => request({
    url: 'customerGroup/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customerGroup_changeFrozenStatus = (id, args) => request({
    url: 'customerGroup/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerGroup_findById = (id, args) => request({
    url: 'customerGroup/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customerGroup_findAllList = (args) => request({
    url: 'customerGroup/findAllList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const customerGroup_delete = (id, args) => request({
    url: 'customerGroup/delete',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customerGroup.js